import SSOPaymentDetail from './SSOPaymentDetail';

export default SSOPaymentDetail;
